import { Component, h, ReadOnlyRef, useRef } from "@lukekaalim/act"
import { TheatreState } from "../../hooks"

import * as three from 'three';
import { useJanitorEffect } from "@kosmod/kit";
import { renderBeat } from "@kosmod/graphics-3d";
import { a3 } from "@lukekaalim/act-three";
import { TheatrePosition } from "../../defs";

export type CursorSurfacePreviewProps = {
  state: TheatreState,
  offset?: three.Vector3Like,
  snap?: null | 'square' | 'vertex',
}

export const CursorSurfacePreview: Component<CursorSurfacePreviewProps> = ({ state, children, offset, snap }) => {
  const ref = useRef<three.Object3D | null>(null);

  useFollowCursor(state, ref, offset, snap);

  return h(a3.object, { ref }, children)
}

export const useFollowCursor = (
  state: TheatreState,
  ref: ReadOnlyRef<null | three.Object3D>,
  offset: three.Vector3Like = new three.Vector3(),
  snap: null | 'square' | 'vertex' = null,
) => {
  renderBeat.useBeat(() => {
    let cursorPosition = state.cursorPosition.get();
    const object = ref.get();

    if (!object)
      return;

    if (!cursorPosition) {
      object.visible = false;
      return;
    }

    switch (snap) {
      case 'square':
        cursorPosition = TheatrePosition.snapToSquareGrid(cursorPosition)
        break;
      case 'vertex':
        cursorPosition = TheatrePosition.snapToSquareGridVertex(cursorPosition)
        break;
    }

    object.visible = true;
    object.position
      .set(cursorPosition.vector.x, 0, cursorPosition.vector.y)
      .add(offset)
  })
}